// extracted by mini-css-extract-plugin
module.exports = {"control":"Form_control__g5TiA","actions":"Form_actions__3Xb7K"};